import { useState } from 'react';
import { useFeatureToggles } from '../../../feature-toggles';
import { useAuthenticatedUser } from '../../../authentication';
import { useIsAllowed } from '../../../authentication/use-is-allowed';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { draftsToggle } from '../chat-standard-question-select';
import { readShowDrafts, storeShowDrafts } from '../show-drafts-storage';

// Called once per chat, so the settings switch and the standard question list read the same choice.
export function useShowDrafts() {
  const userId = useAuthenticatedUser()?.profile.id;
  const { isFeatureEnabled } = useFeatureToggles();
  const mayWriteStandardQuestions = useIsAllowed([{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Write }]);
  const [showDrafts, setShowDrafts] = useState(() => readShowDrafts(userId));
  const draftsAvailable = isFeatureEnabled(draftsToggle) && mayWriteStandardQuestions;

  function changeShowDrafts(checked: boolean) {
    setShowDrafts(checked);
    storeShowDrafts(userId, checked);
  }

  return { draftsAvailable, showDrafts: draftsAvailable && showDrafts, changeShowDrafts };
}
